<template>
  <b-container>
    <div id="initialSearch">
      <b-input-group class="mb-2">
        <b-input
          v-model="searchBy"
          class="form-control"
          placeholder="Search Study ID"
          type="search"
          @keyup.enter="searchProtocols"
        ></b-input>
        <b-input-group-append>
          <b-button type="search" variant="info" @click="searchProtocols">Search</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <hr v-if="protocols.length > 0" />

    <div id="protocols">
      <b-input-group class="mb-2">
        <b-input
          v-if="protocols.length > 0"
          v-model="filter"
          class="form-control"
          placeholder="Filter Studies"
          type="search"
        ></b-input>
      </b-input-group>

      <b-table
        id="protocol-table"
        :busy.sync="busy"
        :current-page="currentPage"
        :fields="fields"
        :filter="filter"
        :items="protocols"
        :per-page="perPage"
        bordered
        class="rounded-lg"
        empty-filtered-text="There are no studies matching your filter."
        head-variant="dark"
        hover
        responsive
        show-empty
        stacked="sm"
        striped
        @filtered="onFiltered"
      >
        <template #table-caption>{{ currentLength }}</template>
        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button pill size="sm" variant="outline-info" @click="selectButtonClicked(data.item)">
            select
          </b-button>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="currentLength"
        align="center"
        aria-controls="users-table"
        pills
      ></b-pagination>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'ProtocolModal',
    props: {},
    data() {
      return {
        protocols: [],
        searchBy: '',
        selectedProtocol: '',
        busy: false,
        filter: '',
        filteredLength: 0,
        currentPage: 1,
        perPage: 10,
        rows: 0,
        fields: [
          {
            key: 'Name',
            label: 'Name',
            sortable: false,
          },
          {
            key: 'Study_ID__c',
            label: 'Study ID',
            sortable: false,
          },
          {
            key: 'Current_Status__c',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'Drug_Program__c',
            label: 'Drug Program',
            sortable: true,
          },
          {
            key: 'Therapeutic_Area__c',
            label: 'Therapeutic Area',
            sortable: true,
          },
          { key: 'actions', label: 'Actions' },
        ],
      };
    },
    computed: {
      currentLength() {
        if (this.filteredLength !== 0) {
          return this.filteredLength;
        }
        return this.protocols.length;
      },
    },
    methods: {
      selectButtonClicked(protocol) {
        this.$emit('updateForm', protocol);
      },
      onFiltered(filteredItems) {
        this.filteredLength = filteredItems.length;
      },
      async searchProtocols() {
        if (this.searchBy === '') {
          return;
        }
        if (this.searchBy.length < 2) {
          alert('Please insert more than two characters in the search box.');
          return;
        }
        this.busy = true;
        this.protocols.length = 0;
        await axios
          .get(` /api/get-protocols?searchKeyword=${this.searchBy}`)
          .then(r => {
            if (r.data['records'] !== null) {
              this.protocols = r.data['records'];
            }
          })
          .catch(e => console.error(e));
        this.busy = false;
      },
      updateForm(event) {
        this.selectedProtocol = event['Study_ID__c'];
        this.$emit('updateForm', this.selectedProtocol);
      },
    },
  };
</script>
